<script>
import get from 'lodash/get'

export default {
  name: 'RelatedProductEdit',
  props: {
    products: {
      type: Array,
      default: () => {},
    },
    formProducts: {
      type: Array,
      default: () => [],
    },
    formRoles: {
      type: Array,
      default: null,
    },
    externalProviders: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getFormProductById(id) {
      return this.formProducts.find(p => p.productId === id) || {}
    },
    productVersion(id) {
      return this.getFormProductById(id).versionId || null
    },
    versionDisabled(id) {
      return this.formProducts.findIndex(p => p.productId === id) === -1
    },
    checkProduct(e, product, index) {
      this.$emit('check-product', e, product.id, index)

      let defaultVersionId
      const versions = product.versions || []
      const haveLatest = versions.find(i => i.id === 'latest')

      if (haveLatest) {
        defaultVersionId = 'latest'
      } else if (versions.length) {
        defaultVersionId = get(versions, '0.id')
      }

      if (defaultVersionId) {
        this.selectVersion(defaultVersionId, product.id)
      }
    },
    selectVersion(event, id) {
      this.$emit('select-version', event, id)
    },
    getUniqueProviderId(productId) {
      const product = this.externalProviders.find(i => i.productId === productId)

      return get(product, 'externalId', '')
    },
    enterProviderId(productId, providerId) {
      this.$emit('change-provider-id', productId, providerId)
    },
  },
}
</script>

<template>
  <!-- TODO Versions -->
  <el-form-item
    v-if="products.length"
    label="Products"
    prop="products"
    :class="$style.products"
  >
    <div :class="$style.label">
      Default Version
    </div>
    <div
      v-for="(product, index) in products"
      :key="index"
      :class="$style.product"
    >
      <el-checkbox
        :key="index"
        :label="product.name"
        :class="$style.productCheckbox"
        :checked="!versionDisabled(product.id)"
        @change="checkProduct($event, product)"
      />
      <el-select
        :key="`select_${index}`"
        :class="$style.productSelect"
        :value="productVersion(product.id)"
        :disabled="versionDisabled(product.id)"
        placeholder="Select version"
        required
        @change="selectVersion($event, product.id)"
      >
        <el-option
          v-for="(version, i) in product.versions"
          :key="i"
          :value="version.id || version.name"
          :label="version.name"
        />
      </el-select>
      <el-select
        v-if="formRoles"
        v-model="formRoles[index]"
        :disabled="versionDisabled(product.id)"
        :class="$style.roleSelect"
        placeholder="Select roles"
        multiple
      >
        <el-option
          v-for="(role, i) in product.roles"
          :key="i"
          :value="role.id"
          :label="role.friendlyName"
        />
      </el-select>

      <el-form-item
        v-if="!formRoles"
        label="Unique Provider ID"
        :prop="product.id"
        :class="$style.providerId"
      >
        <el-input
          :value="getUniqueProviderId(product.id)"
          :disabled="versionDisabled(product.id)"
          :placeholder="versionDisabled(product.id)? '' : 'Enter Product Provider ID'"
          @input="enterProviderId(product.id, $event)"
        />
      </el-form-item>
    </div>
  </el-form-item>
  <!-- /TODO Versions -->
</template>

<style lang="scss" module>
.products {
  position: relative;
  display: flex;
  flex-direction: column;

  :global {

    .el-form-item__content {
      flex-direction: column;
    }

    .el-form-item__error {
      font-size: rem(14px);
    }

    .el-checkbox {
      align-items: center;
      height: rem(40px);
    }

    .el-form-item__label {
      padding-bottom: rem(6px) !important;
    }
  }

  &:global(.is-error > .el-form-item__content) {
    margin-bottom: rem(24px);
  }
}

.product {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin: rem(0 0 20px);
}

.label {
  position: absolute;
  top: rem(-36px);
  right: 0;
  width: 100%;
  padding-left: 14.5rem;
}

.productCheckbox {
  width: rem(200px);
  min-width: rem(200px);
}

.roleSelect {
  display: flex;
  align-items: center;
  margin-left: 1rem;
}

.productSelect,
.providerId {
  min-width: rem(240px);
  max-width: rem(240px);
}

.productSelect {
  min-height: rem(70px);
}

.providerId {
  margin: rem(-40px 0 0 50px);

  :global {
    .el-form-item__label {
      padding: 0 !important;
    }
  }
}
</style>
